import { render } from "./health.vue?vue&type=template&id=286a1320&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"

import "./health.vue?vue&type=style&index=0&id=286a1320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286a1320"]])

export default __exports__